import React from 'react'
import Svg, { G, Path } from 'react-native-svg'

import { A11Role } from '../../../lib/accessibility'

interface ChatbotSummaryImageProps {
  size: number
}

export const SuccessImageProsperia = ({ size }: ChatbotSummaryImageProps) => {
  return (
    <Svg width={size} height={size} viewBox={`0 0 200 200`} fill="none" accessibilityRole={A11Role.SvgImage}>
      <Path
        fill="#CDE6E1"
        d="M159.421 154.314a.832.832 0 0 1-.288.483.832.832 0 0 1-.53.187H40.851l-.084-.463a.701.701 0 0 1-.059-.227v-.138L29.091 88.427c-99.523 16.259 82.451 207.322 154.432 37.671 8.208-19.338 41.139-99.784-18.427-85.17-12.809 3.143-23.934 8.508-34.621 14.504h31.606a2.625 2.625 0 0 1 2.457 1.723c.122.334.175.69.154 1.046l-1.246 21.85"
        opacity={0.5}
      />
      <Path
        fill="#165B60"
        d="M162.239 55.417H81.931l-5.656-4.247H38.003a2.616 2.616 0 0 0-2.62 2.77l.891 16.376.941 17.244 3.636 66.626.06.365a.735.735 0 0 0 .674.463h117.131a.669.669 0 0 0 .665-.626l4.228-74.336 1.241-21.886a2.618 2.618 0 0 0-2.611-2.749Z"
        opacity={0.2}
      />
      <Path
        fill="#fff"
        d="M121.479 24.156a20.225 20.225 0 0 1 2.587-10.026H49.104v133.912h103.138V41.469a20.329 20.329 0 0 1-20.403.266 20.332 20.332 0 0 1-10.36-17.579Z"
      />
      <Path
        fill="#165B60"
        d="M141.704 87.067H61.421a1.04 1.04 0 0 0-1.04 1.04v4.873c0 .574.465 1.04 1.04 1.04h80.283a1.04 1.04 0 0 0 1.039-1.04v-4.873a1.04 1.04 0 0 0-1.039-1.04ZM141.704 105.908H61.421a1.04 1.04 0 0 0-1.04 1.039v4.873a1.04 1.04 0 0 0 1.04 1.039h80.283c.574 0 1.039-.465 1.039-1.039v-4.873c0-.574-.465-1.039-1.039-1.039ZM141.704 66.867H61.421a1.04 1.04 0 0 0-1.04 1.04v4.873c0 .574.465 1.04 1.04 1.04h80.283a1.04 1.04 0 0 0 1.039-1.04v-4.873a1.04 1.04 0 0 0-1.039-1.04ZM111.344 50H60.656c-.362 0-.656.469-.656 1.047v4.906c0 .578.294 1.047.656 1.047h50.688c.362 0 .656-.469.656-1.047v-4.906c0-.578-.294-1.047-.656-1.047ZM111.344 35H60.656c-.362 0-.656.469-.656 1.047v4.906c0 .578.294 1.047.656 1.047h50.688c.362 0 .656-.469.656-1.047v-4.906c0-.578-.294-1.047-.656-1.047ZM141.704 124.576H61.421a1.04 1.04 0 0 0-1.04 1.039v4.873a1.04 1.04 0 0 0 1.04 1.039h80.283c.574 0 1.039-.465 1.039-1.039v-4.873c0-.574-.465-1.039-1.039-1.039ZM40.866 154.294a.849.849 0 0 0 .054.227l-.059-.365.005.138Z"
        opacity={0.3}
      />
      <Path fill="#165B60" d="m40.92 154.521.084.463h.591a.728.728 0 0 1-.675-.463Z" opacity={0.43} />
      <Path
        fill="#165B60"
        d="M169.393 80.052h-81.88l-1.177-.735-14.411-9H31.303a4.504 4.504 0 0 0-4.434 5.28l2.266 12.81 11.603 65.744.064.36a.722.722 0 0 0 .675.468h117.165a.834.834 0 0 0 .818-.67l13.712-69.67a3.848 3.848 0 0 0-.802-3.19 3.843 3.843 0 0 0-2.977-1.397Z"
        opacity={0.4}
      />
      <G fill="#165B60" opacity={0.5}>
        <Path d="M138.496 54.693a2.063 2.063 0 0 0 1.592-.778 2.01 2.01 0 0 0-.261-2.771 2.034 2.034 0 0 0-3.37 1.504c-.018.467.13.924.418 1.291a2.077 2.077 0 0 0 1.621.754ZM142.226 59.852a.493.493 0 0 0 .493-.547 4.26 4.26 0 0 0-4.22-3.697 4.256 4.256 0 0 0-4.22 3.697.482.482 0 0 0 .291.505.49.49 0 0 0 .202.042h7.454Z" />
      </G>
      <Path
        fill="#165B60"
        d="M130.875 52.254a1.199 1.199 0 0 0-1.695.074l-3.942 4.316-1.828-1.601a1.194 1.194 0 0 0-1.318-.176 1.192 1.192 0 0 0-.667 1.152 1.202 1.202 0 0 0 .404.822l2.705 2.38a1.202 1.202 0 0 0 1.68-.089l4.749-5.193a1.194 1.194 0 0 0-.088-1.685Z"
        opacity={0.5}
      />
      <Path fill="#CDE6E1" d="M43.138 17a14.242 14.242 0 1 0 14.345 14.145A14.233 14.233 0 0 0 43.138 17Z" />
      <Path
        fill="#165B60"
        d="M51.142 25.943a2.044 2.044 0 0 0-2.893.126l-6.727 7.367-3.12-2.733a2.044 2.044 0 1 0-2.7 3.07l4.617 4.061a2.052 2.052 0 0 0 2.868-.151l8.107-8.864a2.043 2.043 0 0 0-.151-2.876Z"
        opacity={0.5}
      />
      <Path
        fill="#fff"
        d="M46.138 136a14.243 14.243 0 0 0-2.578 28.229 14.241 14.241 0 0 0 16.923-14.084 14.228 14.228 0 0 0-8.884-13.102A14.233 14.233 0 0 0 46.138 136Z"
      />
      <Path
        fill="#165B60"
        d="M54.142 144.943a2.027 2.027 0 0 0-1.472-.538 2.048 2.048 0 0 0-1.42.664l-6.728 7.367-3.12-2.733a2.04 2.04 0 0 0-2.252-.3 2.033 2.033 0 0 0-1.033 1.175 2.04 2.04 0 0 0 .585 2.194l4.617 4.062a2.053 2.053 0 0 0 2.868-.151l8.107-8.864a2.046 2.046 0 0 0-.151-2.876Z"
        opacity={0.5}
      />
      <Path
        fill="#CDE6E1"
        d="M141.372 7a17.498 17.498 0 0 0-17.011 21.036A17.5 17.5 0 0 0 159 24.382 17.486 17.486 0 0 0 141.372 7Z"
      />
      <Path
        fill="#165B60"
        d="M151.352 17.885a2.498 2.498 0 0 0-.832-.494 2.55 2.55 0 0 0-1.909.081 2.478 2.478 0 0 0-.785.562l-8.202 8.746-3.804-3.245a2.507 2.507 0 0 0-.841-.474 2.556 2.556 0 0 0-1.903.119 2.48 2.48 0 0 0-.772.575 2.377 2.377 0 0 0 .225 3.424l5.629 4.822a2.542 2.542 0 0 0 1.785.605 2.53 2.53 0 0 0 1.711-.784l9.883-10.523a2.387 2.387 0 0 0 .63-1.744 2.397 2.397 0 0 0-.815-1.67Z"
        opacity={0.5}
      />
    </Svg>
  )
}
